import { useQuery } from "react-query";
import { getLeasedEquipmentStatusList } from "../../../../../actions/Utilities/LeasedEquipmentStatus";

export default function useGetStatusList() {
  return useQuery("GetStatus", getLeasedEquipmentStatusList, {
    refetchOnWindowFocus: false,
  });
}
